const browser = typeof window !== "undefined";

export default browser;
